<template>
  <div class="view-content">
    <SiteHeader></SiteHeader>
    <main class="container mt-5">
      <div class="row row-offcanvas row-offcanvas-right" :class="sideBarStatus">
        <slot></slot>
        <div class="col-8 col-lg-4 col-xl-3 sidebar-offcanvas" id="sidebar">
          <Sidebar></Sidebar>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import Sidebar from '@/components/Sidebar'
export default {
  props: [
    'sideBarStatus'
  ],
  components: {
    SiteHeader,
    Sidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ViewContentLSidebarR.vue